export default class WordPosition {

    public constructor(private readonly verseIndex: number,
        private readonly sourceIndex: number,
        private readonly wordIndex: number,
        private readonly partIndex?: number) {
    }

    public getVerseIndex(): number {
        return this.verseIndex;
    }

    public getSourceIndex(): number {
        return this.sourceIndex;
    }

    public getWordIndex(): number {
        return this.wordIndex;
    }

    public getPartIndex(): number {
        return this.partIndex || 0;
    }

    public toString(): string {
        const parts = [
            this.getVerseIndex(),
            this.getSourceIndex(),
            this.getWordIndex(),
            this.getPartIndex()
        ];
        return parts.join('/');
    }
}
